<template>
  <div class="overlay" @click="closeModal">
    <div class="modal-content" :class="{'modal-content-multi': idArr.length > 1}" @click.stop>
      <div class="modal-content-item" v-for="(id,index) in idArr" :key="id" v-show="(index - currentLeftIndex) <= 1 && (index - currentLeftIndex) >= 0">
        <img class="close" src="https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/close.png"
          @click="closeModal" v-show="idArr.length == 1 || index - 1 == currentLeftIndex" />
        <div class="modal-header">
          <img class="logo" src="https://media.tp-link.com.cn/webresource/www_data/v3/imgs/icon/tp_logo_white.png" />
        </div>
        <img class="product-img" :src="`https://media.tp-link.com.cn/webresource/www_data/products/list2021/${id}.png`"
          alt="">
        <div class="product-name" :class="{ two: isTwoLine }" :ref="'productName'+ id">{{ info(id).productName }}</div>
        <div v-show="!isEdit[index]" class="spotlight" :class="{ small: isTwoLine }" @dblclick="handleEdit(index)">
          <ul>
            <li :class="'spotlightItem' + index" v-for="(item, index) in removeStarItems(info(id).spotlight)" :key="index">{{
              item }}</li>
          </ul>
        </div>
        <textarea name="text" v-show="isEdit[index]" class="textarea" v-model="textareaValue[index]" placeholder="请输入内容"></textarea>
        <div v-show="isEdit[index]" class="operate"> <button @click="isEdit[index] = false">取消</button><button @click="save(index,info(id).currentIndex)">保存</button>
        </div>
        <a class="more" target="_blank" :href="`https://www.tp-link.com.cn/product_${id}.html`" v-show="info(id).productState && info(id).productState > 0">了解更多</a>
        <a class="more" target="_blank" v-show="info(id).moreLink && info(id).moreLink.length > 0"
          :href="info(id).moreLink">了解更多同系列产品</a>
      </div>
      <div class="modal-arrow-left" v-show="idArr.length > 2">
        <img @click="currentLeftIndex = currentLeftIndex - 1" v-show="currentLeftIndex > 0" style="cursor: pointer;" src="https://media.tp-link.com.cn/webresource/act/vr/images/icon/arrow_left_normal.png" />
        <img v-show="currentLeftIndex == 0" src="https://media.tp-link.com.cn/webresource/act/vr/images/icon/arrow_left_hover press.png" />
      </div>
      <div class="modal-arrow-right" v-show="idArr.length > 2">
        <img @click="currentLeftIndex = currentLeftIndex +1" v-show="idArr.length - currentLeftIndex > 2" style="cursor: pointer;" src="https://media.tp-link.com.cn/webresource/act/vr/images/icon/arrow_right_normal.png" />
        <img v-show="idArr.length - currentLeftIndex <= 2" src="https://media.tp-link.com.cn/webresource/act/vr/images/icon/arrow_right_hover press.png" />
      </div>
    </div> 
  </div>
</template>

<script>

export default {
  name: 'productInfo',
  props: {
    ids: String,
    morelink: String
  },
  data() {
    return {
      isTwoLine: false,
      PRODUCT_INFO: [],
      textareaValue: ['','','','','','','','',''],
      isEdit: [false,false,false,false,false,false,false,false],
      linkInfos: {},
      currentLeftIndex:0
    }
  },
  computed: {
     // 添加idArr计算属性
    idArr() {
      return this.ids ? this.ids.split(',') : [];
    },
    removeStarItems() {
      let that = this;
      return function (htmlString) {
        let showRows = that.isTwoLine ? 9 : 10;
        let lineNum = 0;
        try {
          // 创建虚拟DOM解析器 [6,7,8](@ref)
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const ul = doc.querySelector('ul');

          // 获取所有<li>并反向遍历（避免索引错位）[2,4](@ref)
          const listItems = ul.querySelectorAll('li');
          const list = [];
          for (let i = listItems.length - 1; i >= 0; i--) {
            const li = listItems[i];
            // 获取纯文本内容（忽略HTML标签）[6,7](@ref)
            const textContent = li.textContent || li.innerText;

            // 检测星号并删除元素 [4,10](@ref)
            if (textContent.includes('*')) {
              li.remove(); // 现代API直接删除
            } else {
              if (i < 10 && lineNum < showRows) {
                if (textContent && textContent.trim().length > 36) {
                  lineNum += 2;
                } else {
                  lineNum++;
                }
                list.push(textContent)
              }
            }
          }

          // 返回处理后的li
          return list;
        } catch (e) {
          console.log(e);
          return htmlString
        }

      }

    },
    info() {
      return (id) => {
        try {
          let PRODUCT_INFO = this.PRODUCT_INFO;

          let currentInfo = PRODUCT_INFO.filter((item, index) => {
            if (item.id == id) {
              item.currentIndex = index;
              return true
            } else {
              return false
            }
          })[0]
          if (currentInfo) {
            currentInfo.morelink = ''
            if (this.morelink != '') {
              currentInfo.moreLink = this.morelink
            } else {
              if (this.linkInfos[id]) {
                currentInfo.moreLink = this.linkInfos[id].moreLink
              }
            }
          }
          return currentInfo ? currentInfo : {
            productModel: '',
            productName: '产品名称',
            spotlight: '<ul><li>暂无产品信息</li></ul>',
            moreLink: '',
            currentIndex:0
          }
        }
        catch (e) {
          return {
            productModel: '',
            productName: '产品名称',
            spotlight: '<ul><li>暂无产品信息</li></ul>',
            moreLink: '',
            currentIndex:0
          }
        }
      }
    }
  },
  mounted() {
    this.checkIfMultiline();
  },
  updated() {
    this.PRODUCT_INFO = window.PRODUCT_INFO || [];
    this.checkIfMultiline();
  },
  methods: {
    reset(){
      this.currentLeftIndex = 0;
    },
    checkIfMultiline() {
      const el = this.$refs['productName'+ this.id]
      if (el) {
        const style = window.getComputedStyle(el)
        const lineHeight = parseFloat(style.lineHeight)
        // console.log(el.clientHeight,lineHeight);
        // 判断当前高度是否超过一行的高度
        this.isTwoLine = el.clientHeight > lineHeight + 1
      }
    },
    closeModal() {
      this.$emit('close');
      this.isEdit = [false,false,false,false,false,false,false,false];
    },
    handleEdit(index) {
      console.log(index)
      this.isEdit[index] = true;
    },
    save(index,currentIndex) {
      console.log(index,this.textareaValue[index])
      let lines = this.textareaValue[index].split("\n").filter(line => line.trim() !== "");
      let urContent = `<ul>${lines.map(line => `<li>${line.trim()}</li>`).join('')}</ul>`;
      console.log(urContent)
      this.PRODUCT_INFO[currentIndex]["spotlight"] = urContent;
      this.isEdit[index] = false
    }
  },
  created() {
    fetch(
      "https://media.tp-link.com.cn/webresource/act/vr/linkInfo.json?" +
      Date.now(),
      {
        mode: "cors",
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          this.linkInfos = data[0]
        }
      })
      .catch((error) => {
        console.error(
          "Error fetching remote data linkInfo, falling back to local data:",
          error
        );
      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "sass:math";

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}

@font-face {
  font-family: 'SourceHanSansCN-Regular';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Regular.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SourceHanSansCN-Bold';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Bold.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'SourceHanSansCN-Heavy';
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.eot');
  src: url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.eot') format('embedded-opentype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.woff') format('woff'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.ttf') format('truetype'), url('https://media.tp-link.com.cn/webresource/tp_web_common/font/common/SourceHanSansCN/SourceHanSansCN-Heavy.svg') format('svg');
  font-weight: normal;
  font-style: normal;
}

.textarea {
  width: 90%;
  height: px2vh(120);
  margin: px2vh(24) auto 0;
  display: block;
  padding: 2px;
}

.operate {
  float: right;
  padding-right: 5%;

  button {
    margin: 5px;
    cursor: pointer;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  overflow-y: scroll;
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: px2vh(1356);
  display: flex;
  justify-content: center;
  padding: 0 px2vh(108);
  box-sizing: border-box;

  &.modal-content-multi{
    justify-content: space-between;
  }

  .modal-arrow-left{
    width: px2vh(48);
    height: px2vh(48);
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: px2vh(-24);
    img{
      width: 100%;
      display: block;
    }
  }

  .modal-arrow-right{
    width: px2vh(48);
    height: px2vh(48);
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: px2vh(-24);
    img{
      width: 100%;
      display: block;
    }
  }


  .modal-content-item{
    background: #fff;
    //margin: px2vh(94) auto px2vh(86);
    width: px2vh(520);
    box-sizing: border-box;
    // max-height: px2vh(900);
    padding-bottom: px2vh(9);
    position: relative;

    .close {
      position: absolute;
      right: 0;
      top: px2vh(-42);
      font-size: 24px;
      cursor: pointer;
      width: px2vh(30);
      height: px2vh(30);
    }

    .modal-header {
      width: 100%;
      height: px2vh(48);
      background: #41558C;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;

      .logo {
        height: px2vh(14);
      }
    }

    

    .product-img {
      width: px2vh(360);
      height: px2vh(405);
      margin: 0 auto;
      display: block;
    }

    .product-name {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vh(24);
      color: #000000;
      letter-spacing: px2vh(0.6);
      text-align: center;
      line-height: px2vh(48);
      font-weight: normal;
      width: px2vh(380);
      margin: 0 auto;

      &.two {
        line-height: px2vh(40);
      }
    }

    .spotlight {
      padding: px2vh(20) px2vh(30) px2vh(30) px2vh(26);
      // border-bottom: px2vh(24) solid #41558C;
      // max-height: px2vh(320);
      overflow: hidden;
      color: #fff;
      box-sizing: border-box;
    }

    .more {
      clear: both;
      font-family: SourceHanSansCN-Heavy;
      font-size: px2vh(14);
      color: #41558C;
      letter-spacing: px2vh(0.28);
      text-align: center;
      line-height: px2vh(20);
      text-decoration: underline;
      display: block;
      margin-bottom: px2vh(10);
      font-weight: 400;
    }
  }

}
</style>
<style lang="scss">
@use "sass:math";

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}

.spotlight ul li {
  font-family: SourceHanSansCN-Regular;
  font-size: px2vh(14);
  color: #000;
  letter-spacing: px2vh(0.28);
  line-height: px2vh(28);
  // margin-bottom: px2vh(4);
  padding-left: px2vh(14);
  display: -webkit-box;
  /* 设置为 WebKit 内核的弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 2;
  /* 限制显示三行 */
  overflow: hidden;
  /* 隐藏超出范围的内容 */
  text-overflow: ellipsis;
  /* 使用省略号 */
  position: relative;

  &::before {
    content: "•";
    position: absolute;
    top: 0;
    left: 0;
    color: #000;
  }
}
</style>
